/* Partner-Popup (sections/partner-popup.liquid)
   Drei Schritte: 1. Button zum Partner  2. zurückkommen und Teilnahme bestätigen  3. Rabattcode
   - erscheint nach Sekunden, Scrolltiefe oder beim Verlassen der Seite – nie über Cookie-Hinweis,
     Warenkorb-Seitenleiste, Menü oder offenem Chatfenster (wartet, bis diese zu sind)
   - ist es offen, werden Chat-Knopf, Cookie-Knopf und Kaufleiste ausgeblendet (Klasse pp-open), damit nichts darüber liegt
   - merkt sich im Browser den Schritt: Wer den Button geklickt hat, wird beim nächsten Besuch einmal an die
     Bestätigung erinnert; der Code erscheint erst nach Bestätigung (und frühestens nach der Mindestzeit)
   - Links mit der Adresse #partner-aktion öffnen das Popup jederzeit
   - Theme-Editor: öffnet sich ohne Fokus-Wechsel und ohne Scroll-Sperre, damit man Texte links ungestört
     eintippen kann; „Vorschau im Editor“ wählt den angezeigten Schritt */
(() => {
  'use strict';

  const DAY = 864e5;
  const HASH = '#partner-aktion';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = !!(window.Shopify && window.Shopify.designMode);
  const instances = new Map();

  const cookieDialogOpen = () => {
    const cmp = document.querySelector('pandectes-cmp');
    const sr = cmp && cmp.shadowRoot;
    if (!sr) return false;
    return Array.from(sr.querySelectorAll('*')).some((el) => {
      if (/^(STYLE|SCRIPT|LINK)$/.test(el.tagName) || el.closest('.widget')) return false;
      const r = el.getBoundingClientRect();
      if (r.width < 120 || r.height < 80) return false;
      const cs = getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.1;
    });
  };
  const visible = (el) => {
    if (!el) return false;
    const cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.1) return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  };
  // Etwas anderes ist gerade offen (auch ein offenes Chatfenster) – dann später noch einmal versuchen
  const busy = () => document.body.classList.contains('no-scroll')
    || !!document.querySelector('.cdrawer.is-open, .drawer.is-open, dialog[open]')
    || visible(document.querySelector('.aibot-window'))
    || cookieDialogOpen();

  function setup(root) {
    if (!root || instances.has(root)) return;
    const dialog = root.querySelector('[data-pp-dialog]');
    const configEl = root.querySelector('[data-pp-config]');
    if (!dialog || !configEl || typeof dialog.showModal !== 'function') return;
    let cfg;
    try { cfg = JSON.parse(configEl.textContent); } catch (e) { return; }

    const key = `lx-partner-popup:${cfg.id}`;
    const read = () => { try { return JSON.parse(localStorage.getItem(key)) || {}; } catch (e) { return {}; } };
    const write = (patch) => {
      if (designMode) return;
      try { localStorage.setItem(key, JSON.stringify(Object.assign(read(), patch))); } catch (e) { /* Speicher blockiert */ }
    };
    const session = {
      get(name) { try { return sessionStorage.getItem(`${key}:${name}`) === '1'; } catch (e) { return false; } },
      set(name) { try { sessionStorage.setItem(`${key}:${name}`, '1'); } catch (e) { /* egal */ } }
    };

    const $ = (sel) => dialog.querySelector(sel);
    const codeBox = $('[data-pp-code]');
    const codeText = $('[data-pp-code-text]');
    const lockedLabel = codeText.textContent;
    const copyBtn = $('[data-pp-copy]');
    const cta = $('[data-pp-cta]');
    const ctaNote = $('[data-pp-cta-note]');
    const confirmBox = $('[data-pp-confirm]');
    const check = $('[data-pp-check]');
    const unlockBtn = $('[data-pp-unlock]');
    const waitEl = $('[data-pp-wait]');
    const waitTime = $('[data-pp-wait-time]');
    const doneBtn = $('[data-pp-done]');
    const unlocked = $('[data-pp-unlocked]');
    const applied = $('[data-pp-applied]');
    const content = $('[data-pp-content]');
    const actions = $('[data-pp-actions]');
    let code = '';
    try { code = decodeURIComponent(escape(atob(codeBox.dataset.c || ''))); } catch (e) { code = ''; }
    const copyLabel = copyBtn ? copyBtn.textContent : '';
    const minMs = Math.max(0, Number(cfg.minMinutes) || 0) * 60000;
    let stage = 'start';
    let waitTimer = 0;
    let timers = [];
    const cleanups = [];

    /* ---------- Schritte ---------- */
    const scramble = (target, text, done) => {
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
      const total = 16;
      let frame = 0;
      const step = () => {
        frame += 1;
        const settled = Math.floor((frame / total) * text.length);
        target.textContent = text.split('').map((ch, i) => (i < settled || ch === ' ' ? ch : chars[Math.floor(Math.random() * chars.length)])).join('');
        if (frame < total) setTimeout(step, 38);
        else { target.textContent = text; if (done) done(); }
      };
      step();
    };
    const remaining = () => {
      if (designMode) return stage === 'pending' ? minMs : 0;
      const clickedAt = read().clickedAt;
      return clickedAt ? Math.max(0, clickedAt + minMs - Date.now()) : minMs;
    };
    const updateWait = () => {
      if (stage !== 'pending') { clearInterval(waitTimer); waitTimer = 0; return; }
      const left = remaining();
      if (waitEl) waitEl.hidden = left <= 0;
      if (left > 0 && waitTime) {
        const m = Math.floor(left / 60000);
        const s = Math.floor(left / 1000) % 60;
        waitTime.textContent = `${m}:${String(s).padStart(2, '0')}`;
      }
      if (unlockBtn) unlockBtn.disabled = left > 0 || !(check && check.checked);
      if (left > 0 && !waitTimer && dialog.open && !designMode) waitTimer = setInterval(updateWait, 1000);
      if (left <= 0 && waitTimer) { clearInterval(waitTimer); waitTimer = 0; }
    };
    const setStage = (next, animate = false) => {
      stage = next;
      dialog.dataset.stage = next;
      const isStart = next === 'start';
      const isPending = next === 'pending';
      const isDone = next === 'revealed';
      if (cta) cta.hidden = !isStart;
      if (ctaNote) ctaNote.hidden = !isStart;
      if (confirmBox) confirmBox.hidden = !isPending;
      if (doneBtn) doneBtn.hidden = !isDone;
      if (unlocked) unlocked.hidden = !isDone;
      if (copyBtn) copyBtn.hidden = !isDone;
      if (isDone && code) {
        codeBox.classList.add('is-revealed');
        codeBox.setAttribute('aria-label', code);
        if (animate && !reduceMotion) {
          codeBox.classList.add('is-animating');
          scramble(codeText, code, () => setTimeout(() => codeBox.classList.remove('is-animating'), 200));
        } else {
          codeText.textContent = code;
        }
        if (applied && read().applied) applied.hidden = false;
      } else {
        codeBox.classList.remove('is-revealed', 'is-animating');
        codeBox.removeAttribute('aria-label');
        codeText.textContent = lockedLabel;
        if (applied) applied.hidden = true;
      }
      updateWait();
    };
    const stageFromStore = () => {
      if (designMode) return ['start', 'pending', 'revealed'].includes(cfg.preview) ? cfg.preview : 'start';
      const st = read();
      if (st.revealed) return 'revealed';
      if (st.clickedAt) return 'pending';
      return 'start';
    };
    const scrollToActions = () => {
      if (!content || !actions) return;
      requestAnimationFrame(() => {
        const top = actions.offsetTop - 16;
        if (content.scrollTop < top) content.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    };

    /* ---------- Öffnen und Schließen ---------- */
    const onClosed = () => {
      clearInterval(waitTimer);
      waitTimer = 0;
      dialog.classList.remove('is-closing', 'is-preview');
      if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('pp-lock');
      if (!document.querySelector('.pp[open]')) document.documentElement.classList.remove('pp-open');
    };
    const open = (source) => {
      if (dialog.open) return;
      setStage(stageFromStore());
      dialog.classList.remove('is-closing');
      // Chat, Cookie-Knopf und Kaufleiste ausblenden, damit nichts über dem Popup liegt (partner-popup.css)
      document.documentElement.classList.add('pp-open');
      if (designMode) {
        // Ohne Modal-Fenster: kein Fokus-Sprung aus den Eingabefeldern des Editors, keine Scroll-Sperre
        dialog.classList.add('is-preview');
        dialog.setAttribute('open', '');
      } else {
        dialog.showModal();
        document.documentElement.classList.add('pp-lock');
        write({ shownAt: Date.now() });
      }
      updateWait();
      if (stage === 'pending' && source !== 'editor') scrollToActions();
    };
    const finishClose = () => {
      if (designMode) { dialog.removeAttribute('open'); onClosed(); return; }
      dialog.classList.remove('is-closing');
      if (dialog.open) dialog.close();
    };
    const close = (remember = true) => {
      if (!dialog.open || dialog.classList.contains('is-closing')) return;
      if (remember) { write({ closedAt: Date.now() }); session.set('closed'); }
      if (reduceMotion || designMode) { finishClose(); return; }
      dialog.classList.add('is-closing');
      setTimeout(finishClose, 280);
    };
    dialog.addEventListener('close', onClosed);
    dialog.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
    dialog.addEventListener('click', (e) => {
      if (e.target.closest('[data-pp-close]')) { close(); return; }
      if (e.target !== dialog) return;
      // Klick auf die abgedunkelte Fläche außerhalb des Fensters
      const r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close();
    });

    /* ---------- Schritt 1 → 2: Klick zum Partner ---------- */
    const onCtaClick = (e) => {
      if (e.type === 'auxclick' && e.button !== 1) return;
      if (!read().clickedAt) write({ clickedAt: Date.now() });
      if (stage === 'start') {
        setStage('pending');
        scrollToActions();
      }
    };
    if (cta) {
      cta.addEventListener('click', onCtaClick);
      cta.addEventListener('auxclick', onCtaClick);
    }

    /* ---------- Schritt 2 → 3: Teilnahme bestätigt ---------- */
    const applyDiscount = () => {
      if (!cfg.autoApply || !code || designMode) return;
      const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(`${rootUrl}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(`${rootUrl}cart.js`)}`, { credentials: 'same-origin' })
        .then((res) => {
          if (!res.ok) return;
          write({ applied: true });
          if (applied) applied.hidden = false;
        })
        .catch(() => { /* Code bleibt sichtbar und kopierbar */ });
    };
    if (check) check.addEventListener('change', updateWait);
    if (unlockBtn) {
      unlockBtn.addEventListener('click', () => {
        updateWait();
        if (unlockBtn.disabled) return;
        write({ revealed: true, confirmedAt: Date.now() });
        setStage('revealed', true);
        applyDiscount();
        if (copyBtn) copyBtn.focus({ preventScroll: true });
      });
    }
    if (doneBtn) doneBtn.addEventListener('click', () => close());
    if (copyBtn) {
      copyBtn.addEventListener('click', async () => {
        let ok = false;
        try { await navigator.clipboard.writeText(code); ok = true; } catch (e) {
          const range = document.createRange();
          range.selectNodeContents(codeText);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          try { ok = document.execCommand('copy'); } catch (err) { ok = false; }
        }
        if (!ok) return;
        copyBtn.textContent = cfg.copied || 'Kopiert';
        clearTimeout(copyBtn._t);
        copyBtn._t = setTimeout(() => { copyBtn.textContent = copyLabel; }, 2200);
      });
    }

    /* ---------- Automatisch zeigen ---------- */
    const deviceOk = () => (window.matchMedia('(max-width: 749px)').matches ? cfg.mobile : cfg.desktop);
    const waitOver = (st) => {
      const wait = (Number(cfg.repeatDays) || 0) * DAY;
      if (!st.closedAt) return true;
      if (!wait) return !session.get('closed');
      return Date.now() - st.closedAt >= wait;
    };
    // „auto“: normale Regeln, „remind“: Button schon geklickt, Code noch nicht freigeschaltet → einmal pro Besuch erinnern
    const autoMode = () => {
      if (!cfg.auto || designMode || !deviceOk()) return null;
      const st = read();
      if (st.revealed) return cfg.hideAfterReveal || !waitOver(st) ? null : 'auto';
      if (st.clickedAt) return session.get('reminded') ? null : 'remind';
      return waitOver(st) ? 'auto' : null;
    };

    let fired = false;
    const tryOpen = () => {
      const mode = autoMode();
      if (fired || !mode) return;
      if (busy()) { timers.push(setTimeout(tryOpen, 1500)); return; }
      fired = true;
      if (mode === 'remind') session.set('reminded');
      open('auto');
    };
    const mode = autoMode();
    if (mode === 'remind') {
      timers.push(setTimeout(tryOpen, 2500));
    } else if (mode === 'auto') {
      const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (cfg.trigger === 'scroll') {
        const onScroll = () => {
          const max = document.documentElement.scrollHeight - window.innerHeight;
          if (max <= 0 || (window.scrollY / max) * 100 >= Number(cfg.scroll || 40)) {
            window.removeEventListener('scroll', onScroll);
            tryOpen();
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        cleanups.push(() => window.removeEventListener('scroll', onScroll));
      } else if (cfg.trigger === 'exit' && isDesktop) {
        const onLeave = (e) => {
          if (e.relatedTarget || e.clientY > 8) return;
          document.removeEventListener('mouseout', onLeave);
          tryOpen();
        };
        // erst nach ein paar Sekunden scharf schalten, damit es nicht sofort beim Laden aufspringt
        timers.push(setTimeout(() => document.addEventListener('mouseout', onLeave), 4000));
        cleanups.push(() => document.removeEventListener('mouseout', onLeave));
      } else {
        timers.push(setTimeout(tryOpen, Math.max(0, Number(cfg.delay) || 0) * 1000));
      }
    }

    setStage(stageFromStore());
    instances.set(root, {
      open,
      close,
      destroy() {
        timers.forEach(clearTimeout);
        timers = [];
        clearInterval(waitTimer);
        cleanups.forEach((fn) => fn());
        if (designMode) { dialog.removeAttribute('open'); onClosed(); } else if (dialog.open) dialog.close();
      }
    });
  }

  const openFirst = () => {
    const first = instances.values().next().value;
    if (first) first.open('link');
    return !!first;
  };

  const init = () => {
    document.querySelectorAll('[data-pp-root]').forEach(setup);
    if (window.location.hash === HASH && !designMode) openFirst();
  };

  // Links mit #partner-aktion öffnen das Popup
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href$="#partner-aktion"]');
    if (!link || link.closest('[data-pp-dialog]')) return;
    if (openFirst()) e.preventDefault();
  });

  // Theme-Editor: neu gerenderte Section sofort wieder zeigen (ohne Fokus-Wechsel)
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-pp-root]');
    if (!root) return;
    setup(root);
    const inst = instances.get(root);
    if (inst) inst.open('editor');
  });
  document.addEventListener('shopify:section:unload', (e) => {
    instances.forEach((inst, root) => {
      if (e.target.contains(root)) { inst.destroy(); instances.delete(root); }
    });
  });
  document.addEventListener('shopify:section:select', (e) => {
    instances.forEach((inst, root) => { if (e.target.contains(root)) inst.open('editor'); });
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    instances.forEach((inst, root) => { if (e.target.contains(root)) inst.close(false); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
